module.exports = __webpack_public_path__ + "img/group-154@2x.0e096c2f.png";